<template>
  <div class="input-content" ref="inputcontent">
    <textarea class="input" @click="bindClick" v-model="value"></textarea>
  </div>
</template>
<script>
import textarea from './textarea.vue'
export default {
  components: { textarea },
  data() {
    return {
      value: ''
    }
  },
  mounted() {
    setTimeout(() => {
      this.value = document.documentElement.clientHeight
    }, 500)
  },
  methods: {
    bindClick() {
      setTimeout(() => {
        let dom = this.$refs.inputcontent
        dom = Array.isArray(dom) ? dom[0] : dom
        console.dir(dom)
        this.value = JSON.stringify(dom.getComputedStyle())
      }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
.input-content {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 999;
  .input {
    width: 100%;
    height: 100px;
  }
}
</style>
